import React from 'react';

const toggleBodyClass = () => {
  const $body = $('body');

  if (!$body.hasClass('menu-on-top')) {
    $body.toggleClass('minified');
    $body.removeClass('hidden-menu');
    $('html').removeClass('hidden-menu-mobile-lock');
  }
};

const MinifyMenuButton = () => (
  <span
    className="minifyme hidden-xs hidden-sm"
    data-action="minifyMenu"
    onClick={toggleBodyClass}
  >
    <i className="fa fa-arrow-circle-left hit"/>
  </span>
);

export default MinifyMenuButton;
